import { createAction, props } from '@ngrx/store'
import { createAsyncConstants } from '../../shared/utils'
import { Appointment, AppointmentRequest, AppointmentDate, AppointmentAvailability, AppointmentAvailabilityRequest } from './appointment.types'

export const APPOINTMENT_DATE = createAsyncConstants('APPOINTMENT_DATE')
export const APPOINTMENT_SELECTED = 'APPOINTMENT_SELECTED'
export const APPOINTMENT_DIALOG = 'APPOINTMENT_DIALOG'
export const APPOINTMENT_AVAILABILITY = createAsyncConstants('APPOINTMENT_AVAILABILITY')

export const requestAppointmentDate = createAction(
  APPOINTMENT_DATE.REQUEST,
  props<{ payload: AppointmentRequest }>()
)

export const appointmentDateSuccess = createAction(
  APPOINTMENT_DATE.SUCCESS,
  props<{ payload: AppointmentDate, meta: { cacheKey: string } }>()
)

export const appointmentDateFailure = createAction(
  APPOINTMENT_DATE.FAILURE,
  props<{ payload: any }>()
)

export const requestAppointmentAvailability = createAction(
  APPOINTMENT_AVAILABILITY.REQUEST,
  props<{ payload: AppointmentAvailabilityRequest }>()
)

export const appointmentAvailabilityFailure = createAction(
  APPOINTMENT_AVAILABILITY.FAILURE,
  props<{ payload: any }>()
)

export const selectAppointment = createAction(
  APPOINTMENT_SELECTED,
  props<{ payload: Appointment }>()
)

export const toggleAppointmentDialog = createAction(
  APPOINTMENT_DIALOG,
  props<{ payload: boolean }>()
)